import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareBoardViewNotFoundRoute: InvariantJiraRoute = {
	name: 'software-board-view-not-found',
	exact: true,
	path: '/jira/software/projects/:projectKey/boards/:boardId/not-found',
};
